import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';
import {
  CancellationSettingsData,
  CancellationSettingsSource,
  CancellationSettingsUpdatePayload,
} from '../../services/cancellation-settings.service';

/**
 * CWS-1776: cancel & refund is switched on per company by Way, from the
 * super-admin company page. Returns a `CancellationSettingsSource` so the
 * shared settings panel can be pointed at one company's settings.
 */
@Injectable({ providedIn: 'root' })
export class AdminCancellationSettingsService {
  private readonly api = inject(ApiService);

  private path(companyId: string): string {
    return `admin/super-admin/companies/${companyId}/cancellation-settings`;
  }

  getSettings(companyId: string): Observable<ApiResponse<CancellationSettingsData>> {
    return this.api.getWithSuperAdminToken<CancellationSettingsData>(this.path(companyId));
  }

  updateSettings(
    companyId: string,
    payload: CancellationSettingsUpdatePayload
  ): Observable<ApiResponse<CancellationSettingsData>> {
    return this.api.putWithSuperAdminToken<CancellationSettingsData>(this.path(companyId), payload);
  }

  forCompany(companyId: string): CancellationSettingsSource {
    return {
      getSettings: () => this.getSettings(companyId),
      updateSettings: payload => this.updateSettings(companyId, payload),
    };
  }
}
